export default "__VITE_ASSET__055535ca__"